package com.nonopn.skydome.common.app.pages.projects

import com.nonopn.skydome.common.app.pages.probes.matchesSearch

// Pure logic of the search field of the "Sites" list.

/**
 * Name of a probe as displayed on the site card: its own name, or null when it is empty or looks like a technical
 * id (the card then shows a generic label, so the search must not use it).
 */
fun displayedProbeName(probeName: String?): String? = probeName?.takeIf { it.isNotBlank() && !it.contains("-") }

/**
 * True when [query] (case and accent insensitive, every word must match) is found in the site name or in the
 * name of its nearest probe.
 */
fun projectMatchesSearch(siteName: String, nearestProbeName: String?, query: String): Boolean =
    matchesSearch(query, siteName, displayedProbeName(nearestProbeName))
